import React from 'react'
import HeroBox from '../components/HeroBox';
import "./Home.css"
import AdminProducts from '../components/admin/AdminProducts';
import Counter from '../components/Counter';
import SEO from '../components/SEO';
import Hero from '../components/Hero';
import Hero2 from '../components/Hero2';
import CarouselProduct from '../components/CarouselProduct';
import FeatureCards from '../components/FeatureCards';
import TrianglePage from '../components/TrianglePage';
import SupportSection from '../components/SupportSection';
import InfoBoxes from '../components/InfoBoxes';

const Home = () => {
  return (
    <div className='home'>
      <SEO
        title="Adcore Consulting - Premier Printing Services"
        description="Discover top-quality printing services at Adcore Consulting, where we bring your ideas to life with care and professionalism."
        keywords="printing, Adcore Consulting, custom prints, Lagos, Nigeria, business cards, design, branding"
        url="https://adcoreconsulting.com"
        image="%PUBLIC_URL%/logo.png"
      />
      
      
      <TrianglePage/>  
      <FeatureCards/>
      <Hero2/>
      <AdminProducts/>
      <SupportSection/>
       <CarouselProduct/>
      {/* <HeroBox/> */}
      <InfoBoxes/>
      <Counter/>
      
    </div>
  )
}

export default Home;
